<div class="ice-breaker-modal">
  <div class="title-wrapper">
    <h3>{{ data.modalTitle }}</h3>
    <button title="close modal" (click)="closeDialog()">
      <mat-icon class="close-icon" aria-hidden="true" data-mat-icon-type="font" (click)="closeDialog()">close</mat-icon>
    </button>
  </div>
  <div class="modal-text">
    <span>Pick an ice breaker topic from the options below and then share it with the group in a toast</span>
  </div>
  <div class="category-wrapper">
    <mat-form-field style="width: 100% !important">
      <mat-label>Category</mat-label>
      <mat-select id="cbo-convo-category" [(ngModel)]="selectedCategory" (selectionChange)="categoryChanged()">
        @for (category of categoryList; track category) {
          <mat-option [id]="'convo-' + category.name" [value]="category">
            {{ category.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (convoList && !createOwnConvo) {
      <div aria-label="Carousel of Convos">
        <ngb-carousel
          #carousel="ngbCarousel"
          [showNavigationArrows]="false"
          [showNavigationIndicators]="false"
          (slide)="onSlide($event)"
        >
          @for (c of convoList; track c; let i = $index) {
            <ng-template ngbSlide [id]="'slideId_' + i">
              <div class="title">
                {{ c.title }}
              </div>
            </ng-template>
          }
        </ngb-carousel>
        @if (convoList.length) {
          <div class="pagination-wrapper">
            <mat-icon role="button" (click)="changeConvo('prev')">chevron_left</mat-icon>
            <div class="dots-wrapper">
              @for (c of convoList; track c; let i = $index) {
                <div class="dot" [ngClass]="{ active: selectedConvoIndex === i }" (click)="changeConvo(i)"></div>
              }
            </div>
            <mat-icon role="button" (click)="changeConvo('next')">chevron_right</mat-icon>
          </div>
        }
      </div>
    }
    @if (createOwnConvo) {
      <div class="create-convo-area">
        <textarea #customconvo [(ngModel)]="ownConvoDescription" (keyup)="customConvoChanged()"></textarea>
        @if (ownConvoError) {
          <p class="error-message">{{ ownConvoError }}</p>
        }
      </div>
    }
  </div>
  <div class="footer-wrapper">
    @if (data.primaryButtonText) {
      <button
        id="btnStartConvo"
        [disabled]="ownConvoError || (!selectedConvo && !ownConvoDescription) || !canStartConvo"
        (click)="startConvo()"
        class="primary-button"
      >
        {{ data.primaryButtonText }}
      </button>
    }
  </div>
</div>
